import formatPercent, { formatNumber } from "./formatValues"

export default function getDashboardCardsList(dashboardData: any) {

    let dashboardCardsInfo = []
    if (dashboardData.length === 0) {

        dashboardCardsInfo = [{
            description: "Anteil Laubwald/Nadelwald",
            value: "N/A",
            metric: ""
        },
        {
            description: "Mittlere Biomasse",
            value: "N/A",
            metric: ""
        },
        {
            description: "Mittlere Baumkronenhöhe",
            value: "N/A",
            metric: ""
        },
        {
            description: "Schadflächen (16-23) Laub-/Nadelwald",
            value: "N/A",
            metric: ""
        },
        {
            description: "Gesamtbiomasse",
            value: "N/A",
            metric: ""
        },
        {
            description: "Kohlenstoffspeicher",
            value: "N/A",
            metric: ""
        }
        ]
    }
    else {
        dashboardCardsInfo = [{
            description: "Laub-/Nadelwald",
            value: formatPercent(dashboardData.laub_prop) + " % / " + formatPercent(dashboardData.nadel_prop),
            metric: "%"
        },
        {
            description: "Mittlere Biomasse",
            value: dashboardData.biomass_t / dashboardData.forest_ha,
            metric: "t/ha"
        },
        {
            description: "Mittlere Baumkronenhöhe",
            value: dashboardData.tree_h_m,
            metric: "m"
        },
        {
            description: "Schadflächen (16-23) Laub-/Nadelwald",
            value: formatNumber(dashboardData.d_laub_20 + dashboardData.d_laub_21 + dashboardData.d_laub_22 + dashboardData.d_laub_23) +
                " ha / " +  formatNumber(dashboardData.d_nade_20 + dashboardData.d_nade_21 + dashboardData.d_nade_22+ dashboardData.d_nade_23),
            metric: "ha"
        },
        {
            description: "Gesamtbiomasse",
            value: dashboardData.biomass_t,
            metric: "t"
        },
        {
            description: "Kohlenstoffspeicher",
            value: dashboardData.kohlen_t,
            metric: "t"
        }
        ]
    }
    return (dashboardCardsInfo)
}

